export default __webpack_public_path__ + "static/media/eye.5690a922.svg";